import useDarkMode from 'use-dark-mode';

import { ThemeMode } from '@swf/core/enums';

import theme from '../themes';

export const useWidgetTheme = (hasLightMode?: boolean) => {
  const isLightModeEnabled = hasLightMode;

  const { value } = useDarkMode(true, {
    onChange: (val?: boolean) => {
      const root = document.getElementById('root');
      if (!root) return;
      if (!val && isLightModeEnabled) {
        root.classList.add(theme[`${ThemeMode.Light}Mode`]);
        root.classList.remove(theme[`${ThemeMode.Dark}Mode`]);
      } else {
        root.classList.add(theme[`${ThemeMode.Dark}Mode`]);
        root.classList.remove(theme[`${ThemeMode.Light}Mode`]);
      }
    }
  });

  const active = !value && hasLightMode ? ThemeMode.Light : ThemeMode.Dark;
  const className = theme[`${active}Mode`];

  return { className, themeMode: active };
};

export default useWidgetTheme;
